import { GET_ORG_TYPES, convertResult } from 'app/common/api/requests/food/school_types/get'

import { api } from 'app/api'

export const getOrgTypes = async (signal?: AbortSignal) => {
  const res = await api.request(GET_ORG_TYPES, {
    additionalAxiosOptions: {
      signal,
    },
    error: 'Не удалось получить типы заведений',
    convertions: {
      convertResult,
    },
  })

  return res
}
